export default __webpack_public_path__ + "static/09-9b0c3bd0ac3cd7e27d54bf152a69998b.jpg";